import styled from '@emotion/styled';
import ImageListItem from '@mui/material/ImageListItem';

// eslint-disable-next-line no-restricted-exports
export { default } from '@mui/material/ImageListItem';

export const ImageBrowserListItem = styled(ImageListItem)`
  cursor: pointer;
  min-height: 344px;
`;
